import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import ResumeList from './ResumeList';
import GetAllResumes from '../helpers/getAllResumes';

const SearchResumes = () => {
  const [resumes, setResumes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [resumesFiltered, setResumesFiltered] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const getAllResumes = async () => {
      try {
        const data = await GetAllResumes();
        setResumes(data);
        setResumesFiltered(data);
      } catch (error) {
        setIsError(true);
        console.error('Error fetching resumes:', error);
      } finally {
        setIsLoading(false);
      }
    };

    getAllResumes();
  }, []);

  useEffect(() => {
    const filtered = resumes.filter((resume) =>
      Object.values(resume).some((value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setResumesFiltered(filtered);
  }, [searchTerm, resumes]);

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Failed to load resumes</div>;

  return (
    <div>
      <h2 className="mx-3 mt-3 resumeTitle">Search resumes</h2>
      <h6>You can pick by position, user, email, or other things that you may pick</h6>
      <div className="search">
        <TextField
          id="outlined-basic"
          value={searchTerm}
          onChange={handleChange}
          placeholder="Type and press Enter"
          variant="outlined"
          fullWidth
          label="Search"
        />
      </div>
      <ResumeList resumesFiltered={resumesFiltered} />
    </div>
  );
};

export default SearchResumes;
